import './PinHeader.css';
import { SvgIcon } from 'components/UIComponents/SvgIcon';

export const PinHeader = () => <SvgIcon iconName="pin" />;
